import React from "react"

import { Wrapper, Number, Heading1, Heading2, Heading3 } from "./styles"

const Heading = ({ className, element }) => (
  <Wrapper className={className}>
    {element.number > 0 && <Number level={element.level}>{element.number}.</Number>}
    {element.level === 1 ? (
      <Heading1
        numbered={element.number > 0}
        id={`mbg-${element.anchor}`}
        dangerouslySetInnerHTML={{ __html: element.text }}
      />
    ) : element.level === 2 ? (
      <Heading2
        numbered={element.number > 0}
        id={`mbg-${element.anchor}`}
        dangerouslySetInnerHTML={{ __html: element.text }}
      />
    ) : (
      <Heading3
        numbered={element.number > 0}
        id={`mbg-${element.anchor}`}
        dangerouslySetInnerHTML={{ __html: element.text }}
      />
    )}
  </Wrapper>
)

export default Heading
